import script from "./DailySalesReportTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DailySalesReportTable.vue?vue&type=script&setup=true&lang=js"

import "./DailySalesReportTable.vue?vue&type=style&index=0&id=10a39a6c&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10a39a6c"]])

export default __exports__